import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(private toastService: ToastService) {}

  private getDetail(error: HttpErrorResponse): string | null {
    const anyErr = error as any;
    const candidates: unknown[] = [
      anyErr?.error?.error, // backend "error" string (your current payload)
      anyErr?.error?.message,
      anyErr?.message,
      anyErr?.statusText,
    ];
    const first = candidates.find((v) => typeof v === 'string' && v.trim());
    return typeof first === 'string' ? first.trim() : null;
  }

  handleError(error: HttpErrorResponse): void {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.error);
      this.toastService.showError('Client Error', error.error.error);
    } else {
      const detail = this.getDetail(error);
      switch (error.status) {
        case 400:
          this.toastService.showError('Bad Request (400)', detail ?? 'Bad request.');
          break;
        case 401:
          // Owned by AuthInterceptor (clears the session, redirects, shows
          // a "Session expired" toast). Re-toasting here produces a double
          // toast — see implementation-guidelines §11.1 + §12.3.
          break;
        case 403:
          this.toastService.showWarn('Forbidden (403)', detail ?? 'Forbidden.');
          break;
        case 404:
          this.toastService.showError('Not Found (404)', detail ?? 'Not found.');
          break;
        case 500:
          this.toastService.showError('Server Error (500)', detail ?? 'An internal server error occurred.');
          break;
        default:
          this.toastService.showError(`Unexpected Error (${error.status})`, detail ?? 'An unexpected error occurred.');
      }
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
  }
}
